function sortUsers(userA, userB) {
  const SORT_KEEP_ORDER = 0

  const groupComparison = userA.group_name.localeCompare(userB.group_name)

  if (SORT_KEEP_ORDER !== groupComparison) return groupComparison

  return userA.username.localeCompare(userB.username)
}

export default {
  SET_USERNAME(state, payload) {
    state.username = payload
  },

  SET_TOKEN(state, payload) {
    state.token = payload
  },

  SET_USER(state, payload) {
    state.user = payload
  },

  ADD_USER(state, payload) {
    const newData = [...state.users, payload]
    state.users = newData.slice().sort(sortUsers)
  },

  SET_USERS(state, payload) {
    state.users = payload
  },

  SET_SURVEY(state, payload) {
    state.survey = payload
  },

  SET_HAS_SURVEY(state, payload) {
    state.hasSurvey = payload
  },

  SET_MESSAGES(state, payload) {
    state.messages = payload
  },

  SET_MODAL_PROPERTIES(state, payload) {
    state.modalProperties = payload
  },

  SET_MODAL_CLONE(state, payload) {
    state.modalClone = payload
  },

  SET_TOGGLE_SURVEY_ADVANCED_SETTINGS_MODAL(state, payload) {
    state.toggleSurveyAdvancedSettingsModal = payload
  },

  SET_MODAL_BTNS(state, payload) {
    state.modalBtns = payload
  },

  SET_MODAL_GROUPS_ADVANCED_SETTINGS(state, payload) {
    state.modalGroupsAdvancedSettings = payload
  },

  SET_MODAL_MEDIA(state, payload) {
    state.modalMedia = payload
  },

  SET_MODAL_TEMPLATE(state, payload) {
    state.modalTemplate = payload
  },

  SET_MODAL_PREVIEW(state, payload) {
    state.modalPreview = payload
  },

  SET_MEDIA_OBJ(state, payload) {
    state.mediaObj = payload
  },

  SET_DELETE_MEDIA(state, payload) {
    state.deleteMedia = payload
  },

  SET_MODAL_FACIAL_CODING(state, payload) {
    state.modalFacialCoding = payload
  },

  SET_FACIAL_CODING_OBJ(state, payload) {
    state.facialCodingObj = payload
  },

  SET_PAGE(state, payload) {
    state.page = payload
  },

  SET_DARK_MODE(state, payload) {
    state.darkmode = payload
  },

  SET_ACC_TYPE(state, payload) {
    state.accType = payload
  },

  SET_FIRST_ACCESS(state, payload) {
    state.firstAccess = payload
  },

  SET_GROUP_NAME(state, payload) {
    state.groupName = payload
  },

  SET_RATE_CARD(state, payload) {
    state.rateCard = payload
  },

  SET_CHANGE_FLOW(state, payload) {
    state.changeFlow = payload
  },

  SET_TAB_BILLING(state, payload) {
    state.tabBilling = payload
  },

  SET_VALUE(state, payload) {
    state.value = payload
  },

  SET_CHART_TYPE(state, payload) {
    state.chartType = payload
  },

  SET_CHART_SETTINGS(state, payload) {
    state.chartSettings = payload
  },

  SET_SHOW_CONFIG(state, payload) {
    state.showConfig = payload
  },

  SET_REPORT_QUESTIONS_DOWNLOAD_CONTROL(state, payload) {
    state.reportQuestionsDownloadControl = payload
  },

  SET_SURVEY_STATUS_WITH_CHART_CONFIG(state, payload) {
    state.surveyStatusWithChartConfig = payload
  },

  // UI CONTROLS

  SET_LOGIN_MODAL(state, payload) {
    state.loginModal = payload
  },

  // QUOTA MUTATIONS

  SET_STEP(state, payload) {
    state.step = payload
  },

  SET_WANTED_COMPLETES(state, payload) {
    state.wantedCompletes = payload
  },

  SET_BASIC_QUESTIONS(state, payload) {
    state.basicQuestions = payload
  },

  SET_ADVANCED_QUESTIONS(state, payload) {
    state.advancedQuestions = payload
  },

  SET_ANSWERS(state, payload) {
    state.answers = payload
  },

  SET_QUOTA_JSON(state, payload) {
    state.quotaJSON = payload
  },

  SET_COMPLETE_CHECKER(state, payload) {
    state.completeChecker = payload
  },

  SET_QUOTA_ORDER(state, payload) {
    state.quotaOrder = payload
  },

  SET_COUNTRY(state, payload) {
    state.country = payload
  },

  SET_STATE(state, payload) {
    state.state = payload
  },

  SET_CREATED_PROJECT(state, payload) {
    state.projectCreated = payload
  },

  SET_LOADING_SAVE_SETTINGS_QUOTA(state, payload) {
    state.loadingSaveSettingsQuota = payload
  },

  SET_LOADING(state, payload) {
    state.loading = payload
  },

  // SCHEME MUTATIONS

  SET_MATRIX_DISPLAY(state, payload) {
    state.matrixDisplay = payload
  },

  SET_MATRIX_FILTER(state, payload) {
    state.matrixFilter = payload
  },

  SET_MATRIX_FILTER_REVERSE(state, payload) {
    state.matrixFilterReverse = payload
  },

  SET_UPDATED_ADVANCED_OPTIONS(state, payload) {
    state.updatedAdvancedOptions = payload
  },

  SET_PARAMS(state, payload) {
    state.params = payload
  },

  SET_VALID_SLIDER(state, payload) {
    state.validSlider = payload
  },

  SET_LOAD_SURVEY(state, payload) {
    state.loadSurvey = payload
  },

  SET_UPDATE_LOG(state, payload) {
    state.updateLog = payload
  },

  SET_PREVIEW(state, payload) {
    state.preview = payload
  },

  SET_UPDATE_QUESTIONS(state, payload) {
    state.updateQuestions = payload
  },

  SET_GROUP_NAME_CHANGE(state, { rename, index }) {
    const result = [...state.questionGroups]

    result[index].group_name = rename

    state.questionGroups = result
  },

  SET_QUESTION_GROUPS(state, payload) {
    state.questionGroups = payload
  },

  SET_SPECIFIC_ADVANCED_OPTION(
    state,
    { questionGroupIndex, questionIndex, advancedKey, value },
  ) {
    const result = [...state.questionGroups]
    result[questionGroupIndex].questions[questionIndex].advancedOptions[
      advancedKey
    ] = value
    state.questionGroups = result
  },

  SET_SPECIFIC_GROUP_ADVANCED_OPTION(state, { questionGroupIndex, advancedKey, value }) {
    const result = [...state.questionGroups]

    const currentAdvancedOptions = result[questionGroupIndex]?.advancedOptions || {}

    currentAdvancedOptions[advancedKey] = value

    result[questionGroupIndex].advancedOptions = currentAdvancedOptions

    state.questionGroups = result
  },

  SET_SPECIFIC_SURVEY_ADVANCED_OPTION(state, { advancedKey, value }) {
    const updatedSurvey = { ...state.survey }

    const currentAdvancedOptions = updatedSurvey?.advancedOptions || {}

    currentAdvancedOptions[advancedKey] = value

    updatedSurvey.advancedOptions = currentAdvancedOptions

    state.survey = updatedSurvey
  },

  SET_SPECIFIC_QUESTION_PROPERTY(
    state,
    { questionGroupIndex, questionIndex, property, value },
  ) {
    const result = [...state.questionGroups]
    result[questionGroupIndex].questions[questionIndex][property] = value
    state.questionGroups = result
  },

  SET_SPECIFIC_GROUP_PROPERTY(state, { questionGroupIndex, property, value }) {
    const result = [...state.questionGroups]
    result[questionGroupIndex][property] = value
    state.questionGroups = result
  },

  SET_SPECIFIC_ANSWER_PROPERTY(
    state,
    { questionGroupIndex, questionIndex, answerIndex, property, value },
  ) {
    const result = [...state.questionGroups]
    result[questionGroupIndex].questions[questionIndex].answers[answerIndex][
      property
    ] = value
    state.questionGroups = result
  },

  SET_NEW_ALTERNATIVES(state, { questionGroupIndex, questionIndex, type, value }) {
    const result = [...state.questionGroups]
    result[questionGroupIndex].questions[questionIndex][type].push(value)
    state.questionGroups = result
  },

  SET_SPECIFIC_LOGIC(state, { questionGroupIndex, questionIndex, logic }) {
    const result = [...state.questionGroups]
    result[questionGroupIndex].questions[questionIndex] = logic
    state.questionGroups = result
  },

  UPDATE_SPECIFIC_QUESTION_GROUP(state, { index, questions }) {
    state.questionGroups[index].questions = questions
    state.questionGroups.mock = null
    delete state.questionGroups.mock
  },

  UPDATE_QUESTION_GROUP(state, { groupIndex, questionGroup }) {
    state.questionGroups[groupIndex] = questionGroup
    state.questionGroups.mock = null
    delete state.questionGroups.mock
  },

  UPDATE_SURVEY_GROUP(state, groups) {
    state.questionGroups = groups.questions_groups
    state.questionGroups.mock = null
    delete state.questionGroups.mock
  },

  SET_CATEGORIES(state, payload) {
    state.categories = payload
  },

  SET_OTHERS(state, payload) {
    state.others = payload
  },

  SET_EXCLUSIVE(state, payload) {
    state.exclusive = payload
  },

  SET_FIX_RANDOM(state, payload) {
    state.fix_random = payload
  },

  SET_SUB(state, payload) {
    state.sub = payload
  },

  SET_CHANGE_CODE(state, payload) {
    state.changeCode = payload
  },

  SET_UPLOADED(state, payload) {
    state.uploaded = payload
  },

  SET_LANGUAGE(state, payload) {
    state.language = payload
  },

  SET_QUESTION_CODE_VALIDATION(state, payload) {
    state.questionCodeValidation = payload
  },

  SET_IS_VISITOR_ACCESS(state, payload) {
    state.isVisitorAccess = !!payload
  },
}
